/* @flow */

import { useIntl } from 'react-intl';
import {
  defaultBraindateSingular,
  defaultBraindatePlural,
} from '@e180/domain/lib/event/setting';
import {
  getEventBraindateSingular,
  getEventBraindatePlural,
  hasEventCustomBraindateName,
} from '@e180/domain/lib/event/util';

import useEvent from './useEvent';
import { capitalizeWords } from 'src/shared/core/util/stringUtil';

export default function useEventBraindateName() {
  const event = useEvent();
  const { locale } = useIntl();
  const braindateSingular =
    getEventBraindateSingular(event, locale) || defaultBraindateSingular;
  const braindatePlural =
    getEventBraindatePlural(event, locale) || defaultBraindatePlural;

  return {
    braindatePlatform: capitalizeWords(braindateSingular),
    braindateSingular,
    braindatePlural,
    hasCustomBraindateName: hasEventCustomBraindateName(event),
  };
}
